import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe, CurrencyPipe } from '@angular/common';

@Pipe({
    name: 'cellcontent',
    standalone: false
})
export class CellContentPipe implements PipeTransform {
  constructor(private datePipe: DatePipe, private currencyPipe: CurrencyPipe) {}

  transform(value: number | string | Date, pipe?: string, resolver?: Function, header?: any) {
    if (resolver !== undefined && header !== undefined) {
      // tslint:disable-next-line: no-unsafe-any
      return resolver(header);
    }
    if (pipe === 'date') {
      return this.datePipe.transform(value, 'dd/MM/yyyy');
    } else if (pipe === 'amount' && (typeof value === 'number' || typeof value === 'string')) {
      // API surface has changed from Angular 5 -> 7
      return this.currencyPipe.transform(value, 'USD', 'symbol', '1.0');
    } else if (pipe === 'intToBool') {
      return value === '1' ? 'Yes' : 'No';
    } else {
      return value;
    }
  }
}
